"use client";
import { useBasketCount } from "lib/apollo/hooks";
import React from "react";
import { useHasMounted } from "utils/wrappers";
import { BasketIcon } from "components/SVG";
import {
  basketIconContainer,
  counterContainer,
  basketCounter
} from "./style.css";
import { colours } from "@shared/ui.design-system";

type BasketCountProps = {
  textColor?: string;
  disabled?: boolean;
};

export const BasketCount: React.FC<BasketCountProps> = ({
  textColor = colours.secondary.light,
  disabled = false
}) => {
  const count = useBasketCount();
  return <Component disabled={disabled} textColor={textColor} count={count} />;
};

type Props = BasketCountProps & {
  count: number;
};

const Component: React.FC<Props> = ({
  textColor = colours.secondary.light,
  disabled,
  count
}) => {
  const mounted = useHasMounted();

  let basketCount = 0;
  if (mounted) basketCount = count;

  return (
    <div className={basketIconContainer}>
      {basketCount > 0 && (
        <div className={counterContainer}>
          <span
            className={basketCounter}
            style={{
              color: textColor,
              fontSize: basketCount > 99 ? "0.875rem" : "0.5rem"
            }}
            data-testid="basket-count"
            aria-label="Basket Count"
          >
            {basketCount < 100 ? basketCount : "∞"}
          </span>
        </div>
      )}
      <BasketIcon
        fill={disabled ? colours.secondary.strong : colours.primary.dark}
      />
    </div>
  );
};
